export default "__VITE_ASSET__Z5o6O923__"